import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import figoAddPet from '../../../assets/home/figo-addpet.png';
import {
  useAddPetBanner,
  usePoliciesValidation,
  useWACostcoValidation,
} from '../../../hooks';

import './AddPetBanner.css';

const COSTCO_GUID = '4BC8B4C4-E147-41F8-8E96-B2E693CC2AD9';

const AddPetBanner = () => {
  const { t } = useTranslation('home');
  const {
    email,
    zipCode,
  } = useSelector(({ session }) => ({
    email: session.userInfo.LoginEmail,
    zipCode: session.userInfo.Address.ZipCode,
  }), shallowEqual);

  const {
    hasAnyFigoPolicy,
    costcoCustomer,
    isWACustomer,
  } = usePoliciesValidation();
  const showBanner = useAddPetBanner();

  const waCostcoValidationFlag = useWACostcoValidation();

  const waCustomerValidation = useMemo(() => {
    if (waCostcoValidationFlag) {
      return !isWACustomer;
    }

    return true;
  }, [waCostcoValidationFlag, isWACustomer]);

  const d2cUrl = useMemo(() => {
    let url = `${process.env.REACT_APP_D2C}/getQuote`
    + `?petZipCode=${zipCode}&email=${email}`;

    if (costcoCustomer && waCustomerValidation) {
      url = `${url}&refer=${COSTCO_GUID}`;
    }
    return url;
  }, [costcoCustomer, waCustomerValidation]);

  return showBanner && hasAnyFigoPolicy ? (
    <div className="Add-pet-banner">
      <img alt="" src={figoAddPet} />

      <div className="Add-pet-banner-info">
        <div className="Add-pet-banner-text">
          <h4>{t('addPet.title')}</h4>

          <p>
            <Trans
              components={{
                bold: <strong />,
              }}
              i18nKey="addPet.description"
              ns="home"
            />
          </p>
        </div>

        <a
          className="Add-pet-banner-button"
          href={d2cUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          {t('addPet.button')}
        </a>
      </div>
    </div>
  ) : null;
};

export { AddPetBanner };
